import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { isEmpty } from 'lodash';

import { ToasterService } from 'common/src/modules/ui-components/toaster';
import { environment } from '../../../../environments/environment';
import { AppState } from '../../../store/state/app.state';
import { ResponseModel } from '../../../shared/models';
import { selectCompanyProfile } from '../../../administration/store/selectors';
import { CompanyProfile } from '../../../administration/models/company-profile.model';
import { AccountingReportsModel, AccountingReportsTaxAuthorityModel } from '../models';
import { DisplayToaster } from '../../../shared/decorators/toaster';


@Injectable()
export class AccountingReportsSettingsService {

  private wid: number;

  private apiUrl(url: string = ''): string {
    return `${environment.javaApiVersion}/workspaces/${this.wid}/reports` + url;
  }

  constructor(
    private readonly toasterService: ToasterService,
    private readonly http: HttpClient,
    private readonly store: Store<AppState>,
  ) {
    this.store.select(selectCompanyProfile)
      .pipe(filter(cp => !!cp && !isEmpty(cp)))
      .subscribe((profile: CompanyProfile) => {
        this.wid = profile.workspaceId;
      });
  }

  public getReportsSettings(): Observable<AccountingReportsModel> {
    return this.http.get<ResponseModel<AccountingReportsModel>>(this.apiUrl('/settings'))
      .pipe(map((settings: ResponseModel<AccountingReportsModel>) => settings.data));
  }

  @DisplayToaster({showErrorMessage: true})
  public updateReportsSettings(settings: AccountingReportsModel): Observable<boolean> {
    return this.http.put<ResponseModel<boolean>>(this.apiUrl('/settings'), {...settings})
      .pipe(map((settings: ResponseModel<boolean>) => settings.data));
  }

  public getReportsAuthorities(): Observable<AccountingReportsTaxAuthorityModel[]> {
    return this.http.get<ResponseModel<AccountingReportsTaxAuthorityModel[]>>(this.apiUrl('/settings/authorities'))
      .pipe(map((settings: ResponseModel<AccountingReportsTaxAuthorityModel[]>) => settings.data));
  }

}
